import { Toaster } from 'react-hot-toast';
import { RouterProvider } from 'react-router-dom';
import './App.css';
import BackToTopButton from './components/BackToTopButton/BackToTopButton';
import router from './Router/Router';
import ProgressBar from "react-scroll-progress-bar";




function App() {

  return (
    <div >
      <ProgressBar bgcolor="#1a0cc4" />

      <div className="mx-auto px-2 sm:px-2 md:px-2 lg:px-6 overflow-hidden">

        <RouterProvider router={router}></RouterProvider>
        <Toaster></Toaster>
        <BackToTopButton></BackToTopButton>
      </div>

    </div>
  );
}

export default App;
